
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<Icon>({})
export default class Icon extends Vue {
	@Prop({ type: String, required: false, default: '' }) private color!: string;

	// Compute the icon class based on the default slot content
	private get iconClass(): string {
		const defaultSlot = this.$slots.default?.[0]?.text?.trim(); // Get the default slot content
		return defaultSlot ? `icon mdi mdi-${defaultSlot}` : 'icon';
	}

	private get iconStyle(): string {
		return this.color ? `color: ${this.color};` : '';
	}
}
